var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoLeonLangFinal = function SvgLogoLeonLangFinal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 1016.733 156.787",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-719.34 719.34) rotate(-55 -3.703 10.566)",
    spreadMethod: "pad",
    id: "logo_leon_lang_final_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d23d19"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f47216"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-719.382 719.382) rotate(-55 -3.393 10.404)",
    spreadMethod: "pad",
    id: "logo_leon_lang_final_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d23d19"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f47216"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-719.415 719.415) rotate(-55 -3.163 10.284)",
    spreadMethod: "pad",
    id: "logo_leon_lang_final_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d23d19"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f47216"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-719.433 719.433) rotate(-55 -3.064 10.233)",
    spreadMethod: "pad",
    id: "logo_leon_lang_final_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d23d19"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f47216"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-719.376 719.376) rotate(-55.001 -4.03 10.736)",
    spreadMethod: "pad",
    id: "logo_leon_lang_final_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d23d19"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f47216"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-719.41 719.41) rotate(-55 -4.246 10.848)",
    spreadMethod: "pad",
    id: "logo_leon_lang_final_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d23d19"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f47216"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-719.335 719.335) rotate(-55 -4.327 10.891)",
    spreadMethod: "pad",
    id: "logo_leon_lang_final_svg__n"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#d23d19"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#f47216"
    },
    offset: 1
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "logo_leon_lang_final_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7363.49 1061.85s-113.41 2.14-167.73-75.393c-.32-.437-.64-.898-.97-1.309 33.77 12.348 64.96 11.774 64.96 11.774s31.32-80.317-9.45-138.52c-19.71-28.183-45.46-45.695-66.74-56.242l25.42-17.781s88.03 16.816 142.03 93.926c53.98 77.187 12.48 183.545 12.48 183.545z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "logo_leon_lang_final_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7057.62 1175.95s-99.37-54.89-107.61-149.16c-.09-.52-.09-1.08-.09-1.65 23.03 27.58 50.3 42.72 50.3 42.72s67.3-53.87 61.08-124.672c-2.95-34.278-16.53-62.286-29.71-82.083l30.91-2.675s67.85 58.476 76.05 152.31c8.2 93.8-80.93 165.21-80.93 165.21z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "logo_leon_lang_final_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6888.38 1019.21c-39.81 85.36-152.75 102.61-152.75 102.61s-58.55-97.2-18.56-182.941c.18-.508.46-.965.68-1.492 6.14 35.418 22.25 62.133 22.25 62.133s85.22-13.071 115.21-77.407c14.56-31.191 16.81-62.226 15.34-85.976l28.14 13.125s29.44 84.668-10.31 169.948z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "logo_leon_lang_final_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6483.87 913.988s-2.14-113.508 75.33-167.773c.52-.313.97-.567 1.43-.899-12.41 33.692-11.86 64.911-11.86 64.911s80.32 31.32 138.53-9.442c28.2-19.726 45.66-45.43 56.21-66.777l17.83 25.41s-16.77 88.027-93.93 142.031c-77.16 54.043-183.54 12.539-183.54 12.539z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "logo_leon_lang_final_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7468.74 657.367c85.4 39.824 102.68 152.696 102.68 152.696s-97.25 58.593-182.96 18.613c-.56-.235-1.07-.508-1.53-.723 35.42-6.172 62.14-22.246 62.14-22.246s-13.03-85.176-77.48-115.234c-31.14-14.473-62.15-16.836-85.91-15.313l13.13-28.117s84.62-29.441 169.93 10.324z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "logo_leon_lang_final_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7460.3 407.191c93.84-8.281 165.25 80.926 165.25 80.926s-54.96 99.336-149.21 107.571c-.56.039-1.07.039-1.65.136 27.59-23.058 42.69-50.312 42.69-50.312s-53.84-67.266-124.65-61.094c-34.27 3.016-62.28 16.504-82.09 29.656l-2.71-30.859s58.54-67.86 152.37-76.024z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "logo_leon_lang_final_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7436.04 349.867c-.46.41-.93.684-1.44 1.004 12.44-33.758 11.85-64.949 11.85-64.949s-80.3-31.281-138.47 9.492c-28.15 19.668-45.7 45.418-56.24 66.699l-17.83-25.383s16.8-88.035 93.92-142.011c77.11-54.039 183.57-12.578 183.57-12.578s2.11 113.547-75.36 167.726z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_leon_lang_final_svg__a)",
    transform: "matrix(.13333 0 0 -.13333 0 156.787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7363.49 1061.85s-113.41 2.14-167.73-75.393c-.32-.437-.64-.898-.97-1.309 33.77 12.348 64.96 11.774 64.96 11.774s31.32-80.317-9.45-138.52c-19.71-28.183-45.46-45.695-66.74-56.242l25.42-17.781s88.03 16.816 142.03 93.926c53.98 77.187 12.48 183.545 12.48 183.545",
    style: {
      fill: "url(#logo_leon_lang_final_svg__b)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_leon_lang_final_svg__c)",
    transform: "matrix(.13333 0 0 -.13333 0 156.787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7057.62 1175.95s-99.37-54.89-107.61-149.16c-.09-.52-.09-1.08-.09-1.65 23.03 27.58 50.3 42.72 50.3 42.72s67.3-53.87 61.08-124.672c-2.95-34.278-16.53-62.286-29.71-82.083l30.91-2.675s67.85 58.476 76.05 152.31c8.2 93.8-80.93 165.21-80.93 165.21",
    style: {
      fill: "url(#logo_leon_lang_final_svg__d)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_leon_lang_final_svg__e)",
    transform: "matrix(.13333 0 0 -.13333 0 156.787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6888.38 1019.21c-39.81 85.36-152.75 102.61-152.75 102.61s-58.55-97.2-18.56-182.941c.18-.508.46-.965.68-1.492 6.14 35.418 22.25 62.133 22.25 62.133s85.22-13.071 115.21-77.407c14.56-31.191 16.81-62.226 15.34-85.976l28.14 13.125s29.44 84.668-10.31 169.948",
    style: {
      fill: "url(#logo_leon_lang_final_svg__f)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_leon_lang_final_svg__g)",
    transform: "matrix(.13333 0 0 -.13333 0 156.787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6483.87 913.988s-2.14-113.508 75.33-167.773c.52-.313.97-.567 1.43-.899-12.41 33.692-11.86 64.911-11.86 64.911s80.32 31.32 138.53-9.442c28.2-19.726 45.66-45.43 56.21-66.777l17.83 25.41s-16.77 88.027-93.93 142.031c-77.16 54.043-183.54 12.539-183.54 12.539",
    style: {
      fill: "url(#logo_leon_lang_final_svg__h)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_leon_lang_final_svg__i)",
    transform: "matrix(.13333 0 0 -.13333 0 156.787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7468.74 657.367c85.4 39.824 102.68 152.696 102.68 152.696s-97.25 58.593-182.96 18.613c-.56-.235-1.07-.508-1.53-.723 35.42-6.172 62.14-22.246 62.14-22.246s-13.03-85.176-77.48-115.234c-31.14-14.473-62.15-16.836-85.91-15.313l13.13-28.117s84.62-29.441 169.93 10.324",
    style: {
      fill: "url(#logo_leon_lang_final_svg__j)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_leon_lang_final_svg__k)",
    transform: "matrix(.13333 0 0 -.13333 0 156.787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7460.3 407.191c93.84-8.281 165.25 80.926 165.25 80.926s-54.96 99.336-149.21 107.571c-.56.039-1.07.039-1.65.136 27.59-23.058 42.69-50.312 42.69-50.312s-53.84-67.266-124.65-61.094c-34.27 3.016-62.28 16.504-82.09 29.656l-2.71-30.859s58.54-67.86 152.37-76.024",
    style: {
      fill: "url(#logo_leon_lang_final_svg__l)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_leon_lang_final_svg__m)",
    transform: "matrix(.13333 0 0 -.13333 0 156.787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7436.04 349.867c-.46.41-.93.684-1.44 1.004 12.44-33.758 11.85-64.949 11.85-64.949s-80.3-31.281-138.47 9.492c-28.15 19.668-45.7 45.418-56.24 66.699l-17.83-25.383s16.8-88.035 93.92-142.011c77.11-54.039 183.57-12.578 183.57-12.578s2.11 113.547-75.36 167.726",
    style: {
      fill: "url(#logo_leon_lang_final_svg__n)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "LEON INMOBILIARIA",
    style: {
      fontWeight: 700,
      fontSize: 58,
      fontFamily: "PalatinoLinotype",
      InkscapeFontSpecification: "PalatinoLinotype-Bold",
      fill: "#393536"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.067 84.07v-3.094c-9.28.232-9.28.232-12.064.232-2.707 0-2.784 0-11.987-.232v3.093l2.861.232c3.635.31 3.635.31 3.712 7.347v34.645c0 2.63-.386 3.712-1.546 4.408l-2.475 1.392v1.779c5.336-.155 7.501-.232 9.512-.232 1.392 0 2.243 0 4.95.077 4.871.155 8.893.232 12.45.232 4.253 0 6.496-.077 10.904-.31l.387-.618.85-12.837h-3.016l-1.778 7.888c0 .077-.078.154-.232.232-2.475.85-4.563 1.082-8.971 1.082-3.17 0-6.187-.077-10.13-.232V91.648c.077-4.64.154-5.878.695-6.496.464-.464 1.16-.696 3.016-.85zM74.16 85.693c4.175-.232 6.573-.31 11.29-.31 4.176 0 7.424.697 7.501 1.547l.619 5.8h2.784l1.083-10.98-.464-.542c-2.784-.232-4.176-.31-7.347-.31-2.165 0-4.33 0-8.352.155-5.104.155-7.424.155-10.053.155-3.248 0-6.806-.078-14.539-.232v2.861l2.861.232c3.558.31 3.635.619 3.712 7.579v34.645c0 2.63-.386 3.712-1.546 4.408l-2.475 1.392v1.779c5.336-.155 7.501-.232 9.512-.232 1.392 0 2.243 0 4.95.077 4.871.155 8.893.232 12.45.232 4.253 0 6.496-.077 10.904-.31l.387-.618.85-12.219h-3.016l-1.778 7.27c0 .077-.078.154-.232.232-2.552.85-4.563 1.082-8.971 1.082-3.17 0-6.187-.077-10.13-.232v-20.648c1.933-.154 3.402-.232 5.18-.232h5.105c3.016.078 4.098.774 4.408 2.862l.464 3.866h3.093l-.232-8.352c0-.618.077-3.325.232-8.274h-3.093l-.464 4.408c-.232 1.314-1.083 1.624-4.408 1.624H79.34c-2.862 0-3.712 0-5.182-.155zM140.663 79.893c-18.792 0-29.696 10.285-29.696 28.072 0 17.168 10.13 26.99 27.84 26.99 18.482 0 29.386-10.44 29.386-28.073 0-17.09-10.13-26.989-27.53-26.989zm-.774 4.33c4.099 0 7.347 1.238 10.054 3.945 4.253 4.253 6.65 11.522 6.65 20.338 0 14.54-5.877 22.118-17.168 22.118-4.33 0-7.501-1.238-10.285-4.022-4.253-4.176-6.573-11.522-6.573-20.416 0-7.965 1.856-14.074 5.413-17.554 3.016-2.939 7.037-4.408 11.91-4.408zM181.263 131.01v2.862c5.104-.155 7.192-.232 8.971-.232s3.712.077 8.739.232v-2.862l-2.862-.232c-3.557-.309-3.712-.618-3.712-7.578V92.808l25.211 30.314c2.088 2.475 4.021 4.718 9.435 10.75l6.341 1.005.541-.31c-.154-4.485-.232-6.031-.232-7.81v-35.11c.078-6.96.155-7.269 3.712-7.578l2.862-.232v-2.861l-8.816.232c-.928 0-2.862 0-8.894-.232v2.861l2.862.232c3.557.31 3.634.619 3.712 7.579v27.762l-24.128-28.149c-1.547-1.856-2.862-3.557-7.966-10.285l-6.496.232h-2.706l-2.63-.078-3.944-.154v2.861l2.862.232c3.557.31 3.634.619 3.712 7.579V123.2c-.078 6.96-.155 7.27-3.712 7.578zM302.987 84.07v-3.094c-9.28.232-9.28.232-12.064.232-2.707 0-2.784 0-11.987-.232v3.093l2.861.232c3.635.31 3.635.31 3.712 7.347V123.2c-.077 4.717-.154 5.954-.696 6.496-.464.464-1.16.696-3.016.85l-2.861.232v3.094c6.496-.155 9.28-.232 11.987-.232 2.784 0 5.49.077 12.064.232v-3.094l-2.862-.232c-1.778-.154-2.474-.309-2.938-.773-.619-.619-.696-1.701-.774-6.573V91.648c.078-4.64.155-5.878.696-6.496.464-.464 1.16-.696 3.016-.85zM315.527 131.01v2.862c5.104-.155 7.192-.232 8.97-.232 1.78 0 3.713.077 8.74.232v-2.862l-2.862-.232c-3.557-.309-3.712-.618-3.712-7.578V92.808l25.21 30.314c2.089 2.475 4.022 4.718 9.435 10.75l6.342 1.005.541-.31c-.155-4.485-.232-6.031-.232-7.81v-35.11c.077-6.96.155-7.269 3.712-7.578l2.861-.232v-2.861l-8.816.232c-.928 0-2.86 0-8.893-.232v2.861l2.861.232c3.558.31 3.635.619 3.712 7.579v27.762l-24.128-28.149c-1.546-1.856-2.86-3.557-7.965-10.285l-6.496.232H322.1l-2.629-.078-3.944-.154v2.861l2.861.232c3.558.31 3.635.619 3.712 7.579V123.2c-.077 6.96-.154 7.27-3.712 7.578zM458.904 83.837v-2.861c-8.12.232-8.12.232-8.971.232-.85 0-.85 0-8.893-.232-2.243 5.336-2.939 6.96-3.79 8.738l-14.152 29.232-12.218-25.52c-.851-1.778-2.166-4.562-5.8-12.45l-9.28.232h-2.707l-2.63-.078-3.943-.154v2.861l2.861.232c3.557.31 3.635.619 3.712 7.579V123.2c-.077 6.96-.155 7.27-3.712 7.578l-2.861.232v2.862c5.104-.155 7.192-.232 8.97-.232 1.779 0 3.712.077 8.739.232v-2.862l-2.861-.232c-3.558-.309-3.712-.618-3.712-7.578V90.952l17.786 37.042c.542 1.16 1.392 3.016 2.784 6.42h2.63c1.469-3.558 1.778-4.332 4.64-10.209l15.93-33.176v32.17c-.077 4.718-.154 5.955-.696 6.497-.464.464-1.16.696-3.016.85l-2.861.232v3.094c6.496-.155 9.28-.232 11.987-.232 2.784 0 5.49.077 12.064.232v-3.094l-2.862-.232c-1.778-.154-2.474-.309-2.938-.773-.619-.619-.696-1.701-.774-6.573V91.648c.078-6.96.155-7.27 3.712-7.579zM501.514 79.893c-18.792 0-29.696 10.285-29.696 28.072 0 17.168 10.131 26.99 27.84 26.99 18.483 0 29.387-10.44 29.387-28.073 0-17.09-10.13-26.989-27.53-26.989zm-.773 4.33c4.099 0 7.347 1.238 10.053 3.945 4.254 4.253 6.651 11.522 6.651 20.338 0 14.54-5.877 22.118-17.168 22.118-4.33 0-7.501-1.238-10.285-4.022-4.254-4.176-6.574-11.522-6.574-20.416 0-7.965 1.856-14.074 5.414-17.554 3.016-2.939 7.037-4.408 11.909-4.408zM542.424 83.837l2.861.232c3.557.31 3.635.619 3.712 7.579v34.645c0 2.63-.387 3.712-1.547 4.408l-2.474 1.392v1.779c5.181-.155 7.346-.232 9.744-.232 1.933 0 4.253.077 7.965.154 2.32.078 2.32.078 3.016.078 12.373 0 20.957-6.96 20.957-16.936 0-4.099-1.546-7.502-4.253-9.435-2.861-1.933-5.413-2.63-11.6-3.016 6.573-2.32 8.739-3.403 11.213-5.645 1.779-1.702 2.862-4.486 2.862-7.424 0-7.038-4.718-10.44-14.616-10.44l-6.419.077c-1.933.077-7.27.155-8.507.155l-6.805-.078-6.11-.154zm17.477 22.89h2.32c8.97 0 12.837 3.403 12.837 11.291 0 8.043-3.634 11.6-11.832 11.6-1.314 0-2.01-.077-3.325-.309zm0-21.575c1.779-.232 2.861-.31 4.408-.31 6.341 0 9.125 2.552 9.125 8.275 0 6.728-3.402 9.59-11.213 9.59h-2.32zM624.37 84.07v-3.094c-9.28.232-9.28.232-12.064.232-2.706 0-2.784 0-11.986-.232v3.093l2.86.232c3.636.31 3.636.31 3.713 7.347V123.2c-.077 4.717-.155 5.954-.696 6.496-.464.464-1.16.696-3.016.85l-2.861.232v3.094c6.496-.155 9.28-.232 11.986-.232 2.784 0 5.49.077 12.064.232v-3.094l-2.861-.232c-1.779-.154-2.475-.309-2.939-.773-.618-.619-.696-1.701-.773-6.573V91.648c.077-4.64.155-5.878.696-6.496.464-.464 1.16-.696 3.016-.85zM661.27 84.07v-3.094c-9.28.232-9.28.232-12.064.232-2.707 0-2.784 0-11.987-.232v3.093l2.862.232c3.634.31 3.634.31 3.712 7.347v34.645c0 2.63-.387 3.712-1.547 4.408l-2.475 1.392v1.779c5.336-.155 7.502-.232 9.512-.232 1.392 0 2.243 0 4.95.077 4.872.155 8.893.232 12.45.232 4.254 0 6.496-.077 10.904-.31l.387-.618.85-12.837h-3.015l-1.78 7.888c0 .077-.076.154-.231.232-2.475.85-4.563 1.082-8.97 1.082-3.171 0-6.187-.077-10.131-.232V91.648c.077-4.64.154-5.878.696-6.496.464-.464 1.16-.696 3.016-.85zM714.937 84.07v-3.094c-9.28.232-9.28.232-12.064.232-2.707 0-2.784 0-11.987-.232v3.093l2.861.232c3.635.31 3.635.31 3.712 7.347V123.2c-.077 4.717-.154 5.954-.696 6.496-.464.464-1.16.696-3.016.85l-2.861.232v3.094c6.496-.155 9.28-.232 11.987-.232 2.784 0 5.49.077 12.064.232v-3.094l-2.862-.232c-1.778-.154-2.474-.309-2.938-.773-.62-.619-.696-1.701-.774-6.573V91.648c.078-4.64.155-5.878.696-6.496.464-.464 1.16-.696 3.016-.85zM761.039 117.71l3.48 8.815c.31.773.464 1.547.464 2.165 0 1.16-.696 2.011-1.547 2.088l-4.098.232v2.862c6.65-.155 10.208-.232 11.754-.232 1.47 0 5.259.077 12.219.232v-2.862l-1.856-.232c-2.165-.309-3.248-1.16-4.253-3.402l-20.03-46.787h-5.49a560.249 560.249 0 0 0-2.166 5.8c-1.082 3.016-1.856 5.027-2.242 5.877l-13.998 33.872c-1.314 3.016-2.629 4.486-4.33 4.64l-2.32.232v2.862c5.722-.155 8.584-.232 8.738-.232.774 0 2.243 0 4.331.077.619.077 2.088.077 4.408.155v-2.862l-3.867-.232c-1.314-.077-2.242-1.16-2.242-2.474 0-.542.154-1.238.386-1.934l3.248-8.66zm-9.821-23.974 8.042 19.642h-15.776zM794.744 130.778v3.094c6.496-.155 9.28-.232 11.987-.232 2.784 0 5.49.077 12.064.232v-3.094l-2.862-.232c-1.778-.154-2.474-.309-2.938-.773-.619-.619-.696-1.701-.774-6.573V85.538c1.083-.464 2.475-.696 4.486-.696 6.96 0 10.904 3.558 10.904 9.9 0 6.495-4.486 10.903-10.982 10.903h-1.392l-.541 1.392 17.323 26.835 6.96-.232c3.944.077 4.64.077 7.501.232v-3.094c-2.784-.54-3.557-1.005-5.413-3.48l-13.998-21.189c4.331-1.779 6.187-2.939 8.275-5.259 2.165-2.474 3.248-5.258 3.248-8.506 0-7.579-4.95-11.368-14.693-11.368-.851 0-2.707 0-5.336.077-2.088.077-8.352.155-10.131.155-2.165 0-2.165 0-13.688-.232v2.861l2.861.232c3.558.31 3.635.619 3.712 7.579V123.2c-.077 4.64-.154 5.954-.696 6.496-.464.464-1.16.696-3.016.85zM880.805 84.07v-3.094c-9.28.232-9.28.232-12.064.232-2.707 0-2.784 0-11.987-.232v3.093l2.862.232c3.634.31 3.634.31 3.712 7.347V123.2c-.078 4.717-.155 5.954-.696 6.496-.464.464-1.16.696-3.016.85l-2.862.232v3.094c6.496-.155 9.28-.232 11.987-.232 2.784 0 5.49.077 12.064.232v-3.094l-2.861-.232c-1.779-.154-2.475-.309-2.939-.773-.619-.619-.696-1.701-.773-6.573V91.648c.077-4.64.154-5.878.696-6.496.464-.464 1.16-.696 3.016-.85zM926.909 117.71l3.48 8.815c.31.773.464 1.547.464 2.165 0 1.16-.696 2.011-1.547 2.088l-4.099.232v2.862c6.651-.155 10.208-.232 11.755-.232 1.47 0 5.259.077 12.219.232v-2.862l-1.856-.232c-2.166-.309-3.248-1.16-4.254-3.402l-20.029-46.787h-5.49a560.249 560.249 0 0 0-2.166 5.8c-1.083 3.016-1.856 5.027-2.243 5.877l-13.997 33.872c-1.315 3.016-2.63 4.486-4.33 4.64l-2.32.232v2.862c5.722-.155 8.583-.232 8.738-.232.773 0 2.243 0 4.33.077.62.077 2.089.077 4.409.155v-2.862l-3.867-.232c-1.315-.077-2.243-1.16-2.243-2.474 0-.542.155-1.238.387-1.934l3.248-8.66zm-9.822-23.974 8.043 19.642h-15.776z"
  }))));
};
export default SvgLogoLeonLangFinal;